const ENProject = {
	"Abrir Projeto": "Open Project",
	"Ações não finalizadas": "Unfinished actions",
	"Adicionar Projeto": "Add Project",
	"Ágil": "Agile",
	"Alterar Projeto": "Change Project",
	"Algumas ações do projeto ainda não foram finalizadas. Deseja finaliza-lo mesmo assim": "Some project actions have not yet been finalized. Do you want to finish it anyway",
	"Adicionar Fase": "Add Phase",
	"Adicionar estratégia": "Add strategy",
	"Controlar Horas": "Controls Hours",
	"Copia": "Copy",
	"Data Estimada": "Estimated Date",
	"Data Prevista (Ações)": "Expected Date (Action)",
	"Data Real (Ações)": "Actual Date (Action)",
	"Datas/Horas": "Dates/Hours",
	"Data início da fase não pode ser menor que a data início do projeto": "Phase start date cannot be less than project start date",
	"Data fim da fase não pode ser maior que a data fim do projeto": "Phase end date cannot be greater than project end date",
	"Deseja realmente excluir o projeto": "Do you really want to delete the project",
	"Digite o título do projeto para excluí-lo": "Enter the title of the project to delete it",
	"Erro ao adicionar projeto": "Error adding project",
	"Erro ao copiar projeto": "Error copying project",
	"Erro ao alterar projeto": "Error changing project",
	"Erro ao excluir projeto": "Error deleting project",
	"Erro ao reordenar projetos": "Error reordering projects",
	"Estratégia é requerida": "Strategy is required",
	"Estratégias não podem ser repetidas": "Strategies cannot be repeated",
	"Exclusão do Projeto": "Project Exclusion",
	"Fases": "Phases",
	"Horas Estimadas": "Estimated Hours",
	"Justificativa": "Reason",
	"Nenhum objetivo adicionado": "No objective added",
	"Nenhuma premissa adicionada": "No added premise",
	"Nenhum projeto encontrado": "No projects found",
	"Objetivos não podem ser repetidos": "Objectives cannot be repeated",
	"Projeto adicionado com sucesso": "Project successfully added",
	"Projeto copiado com sucesso": "Project successfully copied",
	"Projeto alterado com sucesso": "Project successfully changed",
	"Projeto excluído com sucesso": "Project deleted successfully",
	"Projetos reordenados com sucesso": "Projects reordered successfully",
	"Restrições": "Restrictions",
	"Risco associado ao projeto com sucesso": "Risk successful associated with the project",
	"Reordenar Projetos": "Reorder Projects",
	"Ordenar projetos": "Reorder projects",
	"Valor Estimado Despesa": "Estimated Expense Value",
	"Valor Estimado Despesa é requerido": "Estimated Expense Amount is required",
	"Valor Estimado Receita": "Estimated Value Revenue",
	"Valor Estimado Receita é requerido": "Estimated Value Revenue is required",
	"Valor Previsto Despesa (Ações)": "Expected Expense Amount (Actions)",
	"Valor Previsto Receita (Ações)": "Estimated Revenue Amount (Actions)",
	"Valor Real Despesa (Ações)": "Actual Expense Value (Actions)",
	"Valor Real Receita (Ações)": "Actual Revenue Value (Actions)",
	"Valida datas da ação com fase/projeto": "Validate action dates with phase/project",
	"Título do projeto não confere": "Project title does not match",
	"Tradicional": "Traditional"
};

export default ENProject;
